// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailConfiguration.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import { observer } from 'mobx-react';
import action from './Izenda.EmailConfigurationAction';
import { observe } from 'mobx';
import UiState from 'logic/Izenda.UiState';

import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Input from 'share/components/controls/Izenda.Input';
import Button from 'share/components/controls/Izenda.Button';
import Alert from 'share/components/controls/Izenda.Alert';
import SMTPConfiguration from './Izenda.SMTPConfiguration';
import EmailInfo from './Izenda.EmailInfo';

const ConfigurationHeader = observer(function ConfigurationHeader(props: any) {
  const { useSystemConfiguration, localization } = props;

  return (
    <GridLayout className="u-bgWhite u_paddingAll">
      <GridLayout.Row>
        <GridLayout.Col cols={3}>
          <Input
            type="radio"
            className="u_marginRight"
            checked={useSystemConfiguration}
            onChange={props.enableSystemConfig}
          />
          <span>{localization.getText('SMTP_CONFIGURATION_LABEL_USE_SYSTEM_CONFIGURATION')}</span>
        </GridLayout.Col>
        <GridLayout.Col cols={3}>
          <Input
            type="radio"
            className="u_marginRight"
            checked={!useSystemConfiguration}
            onChange={props.enableCustomConfig}
          />
          <span>{localization.getText('SMTP_CONFIGURATION_LABEL_USE_CUSTOM_CONFIGURATION')}</span>
        </GridLayout.Col>
      </GridLayout.Row>
    </GridLayout>
  );
});

const ActionHeader = observer(function ActionHeader(props: any) {
  const { alertDetails, localization } = props;

  return (
    <div className="izenda-Wrapper-header">
      <div className="izenda-Alert-container">
        <Alert type={alertDetails.alertType} onAutoHide={props.onAutoHide}>
          {alertDetails.message}
        </Alert>
      </div>
      <div className="pull-right">
        <Button
          onClick={props.onSave}
          label={localization.getText('COMMON_LABEL_SAVE')}
          className="btn btn-default u_marginRight"
        />
        <Button onClick={props.onCancel} label={localization.getText('COMMON_LABEL_CANCEL')} className='btn-report-default'/>
      </div>
    </div>
  );
});

@connect(action)
export default class EmailConfiguration extends Component {
  componentDidMount() {
    const { store, loader } = this.props;
    store.init();

    loader.startLoading();
    store.loadEmailConfiguration().finally(loader.endLoading.bind(loader));
    this.disposeObserveTenantID = observe(UiState, 'tenantId', () => {
      if (UiState.silentUpdate) return;
      store.loadEmailConfiguration();
    });
  }

  componentWillUnmount() {
    this.props.store.destroy();
    this.props.resetAlert();
    this.disposeObserveTenantID();
  }

  render() {
    const props = this.props;
    const { store, localization } = props;
    const { clonedEmailConfiguration: emailConfiguration, isShowConfiguration, alertDetails } = store;
    const { useSystemConfiguration } = emailConfiguration;

    return (
      <div className="u_paddingAll">
        <ActionHeader
          onSave={props.saveConfig}
          onCancel={props.cancelChangeConfig}
          alertDetails={alertDetails}
          onAutoHide={props.resetAlert}
          localization={localization}
        />
        <div className="izenda-Wrapper-content u_paddingAll">
          {isShowConfiguration && (
            <ConfigurationHeader
              useSystemConfiguration={useSystemConfiguration}
              enableSystemConfig={props.enableSystemConfig}
              enableCustomConfig={props.enableCustomConfig}
              localization={localization}
            />
          )}
          {!useSystemConfiguration && (
            <div>
              <SMTPConfiguration config={emailConfiguration} />
              <EmailInfo config={emailConfiguration} />
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Email/Izenda.EmailConfiguration.js